import { Button } from '@mui/material'
import React from 'react'
import './PrimaryButton.css';


const PrimaryButton = (props) => {
    const { label, onClick, type = 'submit', width = '100%', height = '56px', backgroundColor = 'var(--blue-color-5)', color = 'var(--white-color)', icon: Icon, disabled, className, padding, opacity, sx, disableGrayEffect, disableRipple = false } = props
    return (
        <Button
            type={type}
            onClick={onClick}
            className={`button-PrimaryButton ${className}`}
            disabled={disabled}
            disableRipple={disableRipple}
            style={{
                width: width,
                height: height,
                color: color,
                backgroundColor: backgroundColor,
                padding: padding,
                opacity: opacity,
                ...sx,
                ...(disableGrayEffect && {
                    '&.Mui-disabled': {
                        backgroundColor: backgroundColor,
                        color: color,
                        opacity: opacity ?? 1, 
                        pointerEvents: 'auto !important',
                        cursor: 'not-allowed',
                    }
                })
            }}
        >
            {Icon && <Icon style={{ marginRight: '8px' }} />}
            {label}
        </Button>
    );
};

export default PrimaryButton
